import React from "react";

const DesktopLinks = () => {
  return (
    <>
      <li>
        <p>OUR</p>
        <p>PRODUCTS</p>
      </li>
      <li>
        <p>ABOUT</p>
        <p>US</p>
      </li>
      <li>
        <p>LIVE</p>
        <p>BETTER</p>
      </li>
      <li>
        <p>CLAIMS &</p>
        <p>SUPPORT</p>
      </li>
      <li>
        <p>MY</p>
        <p>ACCOUNT</p>
      </li>
    </>
  );
};

export default DesktopLinks;
